import React from 'react'
import { DisplayIconProps } from '../DisplayIcon.d'

const WifiOffline = ({ classes, inverse, color }: DisplayIconProps) => {
  let strokeFill = color ? color : '#5069C3'
  let accentColor = color ? color : '#FF4C00'
  if (inverse) {
    strokeFill = '#7A7A7A'
    accentColor = '#FFF'
  }

  return (
    <svg
      className={classes}
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='DisplayIcon-WifiOffline'
    >
      <path
        d='M31.9997 49.6879C33.4724 49.6879 34.6663 48.494 34.6663 47.0213C34.6663 45.5485 33.4724 44.3546 31.9997 44.3546C30.5269 44.3546 29.333 45.5485 29.333 47.0213C29.333 48.494 30.5269 49.6879 31.9997 49.6879Z'
        fill={strokeFill}
      />
      <path
        data-testid='DisplayIcon-WifiOffline-strokeFill'
        d='M26.3315 25.9044C22.1104 27.0293 18.3129 29.3699 15.4111 32.6353'
        stroke={strokeFill}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M48.5892 32.6352C45.1651 28.7771 40.5054 26.2304 35.4092 25.4318'
        stroke={strokeFill}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.3155 36.8856C35.0826 35.6888 32.5113 35.2804 30.0174 35.7263C27.5236 36.1721 25.2531 37.4463 23.5732 39.3425'
        stroke={strokeFill}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.9232 17.4965C14.1591 19.3462 10.7893 21.908 8 25.04'
        stroke={strokeFill}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M56.0001 25.04C52.2203 20.7787 47.3749 17.5999 41.9609 15.8297C36.5469 14.0594 30.7595 13.7616 25.1924 14.9667'
        stroke={strokeFill}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        data-testid='DisplayIcon-WifiOffline-accentColor'
        d='M13.333 12.9067L50.6663 50.24'
        stroke={accentColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default WifiOffline
